import type { MenuGroup, MenuLeaf, MenuNode } from '../BittsDropdownMenu/types';

export function useGroupedMenuItems() {
  function isMenuGroup<T>(node: MenuNode<T>): node is MenuGroup<T> {
    return (
      'options' in node &&
      Array.isArray(node.options) &&
      (!('initialOptionsExist' in node) || !node.initialOptionsExist)
    );
  }

  function flattenMenuLeaves<T>(nodes: readonly MenuNode<T>[]): MenuLeaf<T>[] {
    return nodes.flatMap((node) =>
      isMenuGroup(node)
        ? flattenMenuLeaves(node.options)
        : node.children
          ? [node, ...flattenMenuLeaves(node.children)]
          : [node],
    );
  }

  return { isMenuGroup, flattenMenuLeaves };
}
